import { render, staticRenderFns } from "./CampusSelectionForm.vue?vue&type=template&id=79fb83f8&scoped=true&"
import script from "./CampusSelectionForm.vue?vue&type=script&lang=ts&"
export * from "./CampusSelectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./CampusSelectionForm.vue?vue&type=style&index=0&id=79fb83f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fb83f8",
  null
  
)

export default component.exports